/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs list of impound policies (servicing impound lines) on loan for a given impound type
import { QueryFunctionContext, useQueries } from '@tanstack/react-query';
import { fetchImpoundPolicyListData } from '../queryFunctions';

const useImpoundPolicyList = (loanNumber: string, token: string, impGroup: string, impTypes: string[]) => {
  return useQueries({
    queries: impTypes.map((impType, index) => ({
      queryKey: [index, loanNumber, token, impGroup, impTypes, 'impoundPolicyListData'],
      queryFn: ({ signal }: QueryFunctionContext) =>
        fetchImpoundPolicyListData(signal, token, loanNumber, impGroup, impType),
      refetchOnWindowFocus: false,
    })),
    combine: (results) => {
      return {
        data: results.map((result) => result.data),
        status: results.some((result) => result.isPending || result.isFetching)
          ? 'pending'
          : results.some((result) => result.isError)
            ? 'error'
            : 'success',
        error: results.filter((result) => result.isError).map((result) => result.error),
      };
    },
  });
};

export default useImpoundPolicyList;
